import apiRequest from '../config/api'

export interface PublicCertificateData {
  certificate: {
    id: number
    user_id: number
    course_id: number
    name: string
    certificate_number?: string | null
    qr_url?: string | null
    evaluation_score?: string | null
    evaluation_passed?: boolean | null
    evaluation_passing_grade?: string | null
    created_at?: string
  }
  course: {
    id: number
    title: string
    type: string
    questions_count?: string | number
    min_passing_score?: string | null
    studied?: string[]
    certificate_materials?: Array<{
      topic?: string | null
      jpl?: string | null
      speaker?: string | null
    }> | null
    start_date?: string | null
    end_date?: string | null
    certificate_event_dates?: string | null
    certificate_jpl_total?: string | null
    certificate_jpl_note?: string | null
    certificate_speakers?: string | null
    certificate_location?: string | null
  } | null
}

export interface PublicCertificateResponse {
  message: string
  data: PublicCertificateData
}

export const getPublicCertificate = async (
  certificateNumber: string,
): Promise<PublicCertificateResponse> => {
  await apiRequest.getCsrfCookie()
  const encodedNumber = encodeURIComponent(certificateNumber)
  const res = await apiRequest.get(
    `/api/public/certificates?number=${encodedNumber}`,
  )
  return res.data
}
